/**
 * THE close glyph — one asset, three call sites: `button.tsx`'s `CloseIcon`, the
 * SearchField clear control and the SearchPanel close button.
 *
 * ⚠ THIS IS NOT AN ICON LAYER, and it adds nothing to CLAUDE.md's register of
 * owned glyphs — that register lists ASSETS with the argument each one made,
 * not files. A further asset still has to make one of those arguments for
 * itself, in full; see the magnifying glass in `search-field.shared.tsx`, which
 * is flagged on the design-conflicts page as exactly that.
 *
 * Constants rather than a component, so a Server Component, its client twin and
 * a molecule can each render it at their own size without importing one
 * another. The fill is replaced by `currentColor` at every call site.
 */
export const CLOSE_GLYPH_VIEWBOX = "0 0 20 20";

export const CLOSE_GLYPH_PATH =
  "M13.7322 5.28594C14.0034 5.01479 14.443 5.01476 14.7142 5.28594C14.9852 " +
  "5.55714 14.9853 5.99678 14.7142 6.26793L10.9821 10L14.7142 13.7321C14.9851 " +
  "14.0033 14.9852 14.443 14.7142 14.7141C14.443 14.9853 14.0028 14.9853 " +
  "13.7316 14.7141L9.99952 10.9815L6.26796 14.7141C5.9968 14.9851 5.55713 " +
  "14.9851 5.28597 14.7141C5.01477 14.4429 5.01477 14.0028 5.28597 " +
  "13.7316L9.01699 9.99949L5.28597 6.26793C5.01477 5.99673 5.01477 5.55714 " +
  "5.28597 5.28594C5.55717 5.01479 5.99678 5.01476 6.26796 5.28594L9.99952 " +
  "9.0175L13.7322 5.28594Z";
